import { gql } from '@apollo/client';

export const UPDATE_ARREST_INCIDENT_ALL_FIELDS = gql`
  mutation addOrUpdateArrestInIncident($input: AddOrUpdateArrestInIncidentInput!) {
    addOrUpdateArrestInIncident(input: $input) {
      clientMutationId
      errors
      incidentArrestUuid
      incidentUuid
      incidentArrest {
        id
        arrestee {
          id
          personalAttribute {
            id
            firstName
            lastName
          }
        }
        arrestor {
          id
          deptAttribute {
            id
            badge
            ori {
              id
              oriName
              abbreviation
            }
          }
          personalAttribute {
            id
            firstName
            lastName
          }
        }
        arrestedAt
        ibrMultipleArrestType {
          id
          name
        }
        location {
          city
          id
          lat
          lng
          name
          state
          streetName
          streetNumber
          unit
          zip
        }
        citedAt
        arresteeWeaponTypes {
          id
          name
        }
        ibrArrestType {
          id
          name
        }
        ibrClearanceCode {
          id
          name
        }
        arrestCharges {
          id
          nibrsSelected
          offenseViolationPrototype {
            id
            maxPenalty
            minPenalty
            fullName
            name
            offenseCategory {
              id
              name
              oriId
              position
            }
            offenseSubCategory {
              id
              name
              oriId
              position
            }
            oriId
            points
            waiver
            yoe
          }
        }
        exceptionClearedAt
        ibrJuvenileDisposition {
          id
          name
        }
        childUnderEighteen
        printsPhotosNeeded
      }
    }
  }
`